import {call, put, takeLatest,} from "@redux-saga/core/effects";
import * as Services from "../../Services/";
import {ContactsActions} from './Slice';
import {DELETE_CONTACT, GET_CONTACTS, ISaveContact, ISearchContact, SAVE_CONTACT} from "./Types"

import {PayloadAction} from "@reduxjs/toolkit";
import {ModalActions} from "../Modal/Slice";
import {comparator, setLoadingPending, setLoadingRejected, setLoadingResolve, toast} from "../../Utils/Utils";
import Contact from "../../Models/Contact";
import {LOADING_CONTACTS, LOADING_SAVE_CONTACT} from "../Loading/Types";
import {CONTACT_MODAL} from "../Modal/Types";

function* getContacts(action?: PayloadAction<ISearchContact>) {
  try {
    yield put(setLoadingPending(LOADING_CONTACTS));
    const res = yield call(Services.getContacts, action?.payload);
    yield put(setLoadingResolve(LOADING_CONTACTS));
    if (!res?.results) {
      throw Error('There was an error.');
    } else {
      const contacts: any = res.results;
      contacts.sort(comparator());
      yield put(ContactsActions.setContacts(contacts));
    }
  } catch (e) {
    toast("There was an error, please try again.", "error");
    console.error(e);
    yield put(setLoadingRejected(LOADING_CONTACTS, e.message));
  }
}

function* saveContact({payload}: PayloadAction<ISaveContact>) {
  try {
    yield put(setLoadingPending(LOADING_SAVE_CONTACT));

    if (!(payload.contact as Contact)._KEY) {
      const contact = payload.contact;
      const _searchContact: any = {
        customer: contact.customer,
        name: contact.name,
        last_name: contact.last_name
      };
      const contacts = yield call(Services.getContacts, _searchContact);
      if (contacts.results.length > 0) {
        throw Error('El contacto ya existe.');
      }
    }

    const res = yield call(Services.saveContact, payload.contact);
    if (!res?.success) {
      throw Error('There was an error.');
    } else {
      const contact = {...payload.contact};
      if (res.keys) contact._KEY = res.keys[0];
      yield put(ModalActions.closeModal({modal: CONTACT_MODAL, result: contact}));
      const customer = payload.contact.customer
      yield call(getContacts, {payload: {customer}} as PayloadAction<ISearchContact>)
      yield put(setLoadingResolve(LOADING_SAVE_CONTACT));
    }
  } catch (e) {
    toast(e.message || "There was an error, please try again.", "error");
    yield put(setLoadingRejected(LOADING_SAVE_CONTACT, e.message));
  }
}

function* deleteContact({payload}: any) {
  try {
    const res = yield call(Services.deleteContact, payload);
    if (!res?.success) {
      throw Error('There was an error.');
    } else {
      yield call(getContacts, {payload: {customer: payload.customer._KEY}} as PayloadAction<ISearchContact>)
    }
  } catch (e) {
    toast("There was an error, please try again.", "error");
    console.error(e);
  }
}

export function* contactSaga() {
  yield takeLatest(GET_CONTACTS, getContacts);
  yield takeLatest(SAVE_CONTACT, saveContact);
  yield takeLatest(DELETE_CONTACT, deleteContact);
}
